import type { FilterConfig, MultiFilterConfig, RangeFilterConfig } from './types'

export const isMultiFilter = (filter: FilterConfig): filter is MultiFilterConfig => (filter.type ?? 'multi') === 'multi'
export const isRangeFilter = (filter: FilterConfig): filter is RangeFilterConfig => filter.type === 'range'
